export const modalDescriptions = {
  airport: {
    title: '¿Qué incluye nuestro servicio de traslado al aeropuerto?',
    subtitle: '✈️ Traslado al aeropuerto',
    image: '/img/modalDescription/airport.webp',
    imageAlt: 'Coche para traslado al aeropuerto',
    ariaLabel: {
      orderButton: 'Ir al formulario de reserva para traslado al aeropuerto',
      orderButtonText: 'Reservar traslado',
      closeButton: 'Cerrar ventana modal',
    },
    list: [
      'El conductor lo esperará con un cartel en la salida del terminal.',
      'Asistencia con el equipaje.',
      'Seguimiento de vuelo (sabemos si hay retraso).',
      'Hasta 60 minutos de espera gratuita.',
      'Vehículos de clase premium (Wi-Fi, agua, silla para niños a pedido).',
      'Rutas disponibles: desde/hacia el aeropuerto Václav Havel.',
      'Precios desde 30 euros.',
    ],
    text: 'Nuestro traslado al aeropuerto garantiza un inicio o final tranquilo de su viaje. Seguimos su vuelo y lo recibimos con un cartel en la zona de llegadas. El conductor le ayudará con el equipaje y lo llevará en un coche cómodo con Wi-Fi directamente a su destino. La primera hora de espera es gratuita, así que no tendrá que preocuparse si el vuelo se retrasa.',
  },

  corporate: {
    title: 'La solución ideal para empresas',
    subtitle: '🧑‍💼 Traslado corporativo',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: 'Coche de clase ejecutiva para clientes corporativos',
    ariaLabel: {
      orderButton: 'Ir al formulario de reserva para traslado corporativo',
      orderButtonText: 'Reservar traslado',
      closeButton: 'Cerrar ventana modal',
    },
    list: [
      'Servicio para clientes corporativos.',
      'Posibilidad de firmar contrato con la empresa.',
      'Informes mensuales y pago por factura.',
      'Conductores con traje y viajes confidenciales.',
      'Vehículos desde clase ejecutiva o superior.',
      'Reservas para eventos, conferencias y delegaciones.',
      'Seguimiento de ruta a través del portal corporativo.',
    ],
    text: 'Ofrecemos un servicio premium para empresas que valoran la comodidad y la puntualidad. Los traslados entre hoteles, salas de conferencias y aeropuertos son realizados por conductores profesionales con experiencia en atender a clientes VIP. Se puede firmar contrato y pagar mensualmente por factura. Sus empleados llegarán a tiempo y de forma segura.',
  },

  personal: {
    title: 'Su conductor por un día, una semana o un viaje',
    subtitle: '🚗 Conductor personal',
    image: '/img/modalDescription/personal.webp',
    imageAlt: 'Conductor personal con coche de clase premium',
    ariaLabel: {
      orderButton: 'Ir al formulario de reserva para conductor personal',
      orderButtonText: 'Reservar conductor',
      closeButton: 'Cerrar ventana modal',
    },
    list: [
      'Alquiler por horas o por día completo.',
      'Desplazamientos por la ciudad, paradas y esperas incluidas.',
      'Coches de clase premium con conductor.',
      'Viajes privados, compras, reuniones importantes.',
      'Ideal para turistas, clientes VIP y personas mayores.',
      'Conductores que hablan inglés y checo.',
    ],
    text: 'Alquilar un conductor personal es la mejor opción para quienes buscan movilidad y libertad sin complicaciones. Nuestro conductor lo acompañará durante todo el recorrido, sin importar la complejidad. Puede reservar para hacer compras, asistir a reuniones o viajes fuera de la ciudad. Vehículo premium, atención amable y total privacidad — todo incluido.',
  },

  vip: {
    title: 'Lujo y comodidad de primera clase',
    subtitle: '👑 Servicios VIP y de lujo',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Coche VIP listo para el viaje',
    ariaLabel: {
      orderButton: 'Ir al formulario de reserva para servicio VIP',
      orderButtonText: 'Reservar traslado VIP',
      closeButton: 'Cerrar ventana modal',
    },
    list: [
      'Enfoque personalizado para cada cliente.',
      'Vehículos de gama más alta.',
      'Conductores con traje, experiencia en clientes VIP.',
      'Privacidad total.',
      'Opciones adicionales: kit de bienvenida, agua mineral, periódicos.',
      'Ideal para reuniones de negocios, viajes diplomáticos, bodas y eventos sociales.',
      'Soporte 24/7 y gestor personal.',
    ],
    text: 'Alquilar un conductor personal es la mejor opción para quienes buscan movilidad y libertad sin complicaciones. Nuestro conductor lo acompañará durante todo el recorrido, sin importar la complejidad. Puede reservar para hacer compras, asistir a reuniones o viajes fuera de la ciudad. Vehículo premium, atención amable y total privacidad — todo incluido.',
  },

  tours: {
    title: 'Viaje con comodidad y placer',
    subtitle: '🌍 Tours y excursiones',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Vehículo para tours y excursiones por Europa',
    ariaLabel: {
      orderButton: 'Ir al formulario de reserva de tour o excursión',
      orderButtonText: 'Reservar tour',
      closeButton: 'Cerrar ventana modal',
    },
    list: [
      'Organización de tours individuales y en grupo.',
      'Posibilidad de elegir guía o solo conductor.',
      'Rutas flexibles por Chequia y Europa (Karlovy Vary, Viena, Dresde, Múnich, etc.).',
      'Coches cómodos con aire acondicionado, Wi-Fi, agua potable.',
      'Paradas para fotos, compras y comidas en restaurantes locales.',
      'Seguro de viaje y asistencia durante el recorrido.',
      'Reserva disponible mediante formulario en línea.',
    ],
    text: 'Descubra Europa con nosotros — sin estrés ni preocupaciones. Organizamos tours individuales o grupales según sus intereses y preferencias. Puede contar con un guía o simplemente disfrutar de un viaje cómodo con un conductor profesional. Todas las rutas están diseñadas para ofrecer comodidad, seguridad y experiencias inolvidables.',
  },
};
